export default __webpack_public_path__ + "static/9cfab485a55b61f3e48c5c5a0e8e8406.jpg";